export default __webpack_public_path__ + "static/media/Gotham-Book.7f34eb05.otf";